export { default } from './get-display-texts'
